// adjust anchors
document.addEventListener('DOMContentLoaded', ()=>{
  if(location.href.match('/apps/help-center')) {
    return;
  }
  let anchors = document.querySelectorAll(`a[href^="#"]`);
  const path = `${location.origin}${location.pathname}`;
  console.log(path);
  if(path == location.origin + '/' || path == location.origin) {
    anchors = document.querySelectorAll(`a[href^="#"], a[href^="/#"]`);
  }
  if(anchors != null) {
    anchors.forEach((a)=>{
      if(a.getAttribute('href') != null) {
        if(a.getAttribute('href').match('#') && a.getAttribute('href').length > 1) {
          a.addEventListener('click', (e)=>{
            e.preventDefault();
            let target = document.querySelector(a.getAttribute('href').replace('/', '')).getBoundingClientRect().top;
            const header_heigt = document.querySelector('#SiteHeader').clientHeight;
            target = target - header_heigt;
            window.scrollBy({
              behavior: "smooth",
              top: target,
            });
            history.pushState(null, null, a.getAttribute('href'))
          }, true);
        }
      }
    });
  }
  if(location.href.match('#')) {
    setTimeout(()=>{
      const target = document.querySelector(location.hash);
      if(target != null) {
        let dist = window.scrollY + target.getBoundingClientRect().top - document.querySelector('#SiteHeader').clientHeight;
        window.scrollTo({
          behavior: "smooth",
          top: dist,
        });
      }
    }, 100);
  }
});
// adjust anchors

// close drawer when click mobile nav link
document.addEventListener('DOMContentLoaded', ()=>{
  const as = document.querySelectorAll('.mobile-nav__link');
  if(as != null) {
    as.forEach((elm)=>{
      elm.addEventListener('click', ()=>{
        theme.NavDrawer.close();
      });
    });
  }
});
// close drawer when click mobile nav link

// move currency selector into drawer
document.addEventListener('DOMContentLoaded', ()=>{
  if(window.innerWidth <= 768) {
    const currency_selector = document.querySelector('#localization_formtoolbar');
    document.querySelector('.drawer-currency-container').appendChild(currency_selector);
  }
});

// move currency selector into drawer